import * as angular from "angular";
import {SignupRequestsService} from "./services/signup-requests.service";

angular
  .module('bringoz.admin.authentication')
  .config(authenticationConfig);


/* @ngInject */
function authenticationConfig($stateProvider, $authProvider, apiConfig, $httpProvider) {


  //Setup satellizer $authProvider

  $authProvider.loginUrl = apiConfig.baseUrl + `/iam/authenticate`;
  $authProvider.tokenPrefix = 'admin';
  // $authProvider.baseUrl = '/deliveries/table';
  $authProvider.google({
    clientId: apiConfig.google.clientId,
    url: apiConfig.baseUrl + `/iam/authenticate/google`
  });

  $authProvider
    .oauth2({
      name: 'microsoft',
      clientId: apiConfig.microsoft.clientId,
      url: apiConfig.baseUrl + `/iam/authenticate/microsoft`,
      authorizationEndpoint: 'https://login.microsoftonline.com/' + apiConfig.microsoft.tenantId + '/oauth2/v2.0/authorize',
      redirectUri: window.location.origin,
      requiredUrlParams: ['scope'],
      scope: ['User.Read'],
      scopeDelimiter: ' '
    });

  $httpProvider.interceptors.push('AuthInterceptor');

  $stateProvider
    .state('authentication', {
      abstract: true,
      views: {
        'root': {
          templateUrl: 'app/modules/authentication/layouts/authentication.html'
        }
      },
      resolve: {
        intercomUpdate: function (intercom) {
          intercom.toggleShowDefaultLauncher(true);
        }
      }
    })
    .state('authentication.login', {
      url: '/login?authError',
      template: '<login-view></login-view>'
    })
    .state('authentication.reset', {
      url: '/reset?token&:e',
      controllerAs: 'vm',
      template: '<reset-view token="vm.token" email="vm.email"></reset-view>',
      controller: function (token, $stateParams) {
        this.token = token;
        this.email = decodeEmail($stateParams.e);

        function decodeEmail(encoded: string): string | null {
          try {
            const normalized = encoded
              .replace(/-/g, '+')
              .replace(/_/g, '/');

            return atob(normalized);
          } catch {
            return null;
          }
        }
      },
      resolve: {
        token: function ($q, $stateParams) {
          return $stateParams.token || $q.reject();
        }
      }
    })
    .state('authentication.signup', {
      url: '/signup?token?skipValidation',
      template: '<reset-view subscription="vm.subscription" token="vm.token"></reset-view>',
      controllerAs: 'vm',
      controller: function (subscription, token) {
        this.subscription = subscription;
        this.token = token;
      },
      resolve: {
        subscription: function (signupRequestsService: SignupRequestsService, token, $state, $stateParams) {
          return signupRequestsService.getPurchasedSubscription(token)
            .then(function (subscription: any) {
              if (subscription.subscriptionStatus !== 'PendingFulfillmentStart' && !$stateParams.skipValidation) {
                $state.go('authentication.login');
              }
              return subscription;
            });
        },
        token: function ($q, $stateParams) {
          return $stateParams.token || $q.reject();
        }
      }
    })
    .state('authentication.forgot', {
      url: '/forgot',
      params: {
        user: null
      },
      template: '<forgot-password-view></forgot-password-view>'
    });

}
